import TextField from "./TextField";
import {
  PRE_ACTIVATION_INPUT_SX_MULTILINE,
  PRE_ACTIVATION_INPUT_SX_MULTILINE_READONLY,
  PRE_ACTIVATION_OUTLINED_INPUT_SX,
  READ_ONLY_TEXT_MAX_ROWS,
} from "../../utils/colors";

const IntakeTextField = ({
  readOnly = false,
  multiline = false,
  minRows,
  maxRows,
  disabled,
  sx,
  type = "text",
  InputProps,
  ...rest
}) => {
  const isNumericField = type === "number";
  const useReadOnlyTextMode = readOnly && !isNumericField;

  const resolvedMultiline = useReadOnlyTextMode ? true : multiline;
  const resolvedMinRows = useReadOnlyTextMode ? (minRows ?? 1) : minRows;
  const resolvedMaxRows = useReadOnlyTextMode
    ? READ_ONLY_TEXT_MAX_ROWS
    : maxRows;
  const resolvedDisabled = useReadOnlyTextMode
    ? false
    : readOnly
      ? true
      : disabled;
  const resolvedType = readOnly && isNumericField ? "text" : type;
  const resolvedInputProps = useReadOnlyTextMode
    ? { ...InputProps, readOnly: true }
    : InputProps;
  const resolvedSx =
    sx ??
    (useReadOnlyTextMode
      ? PRE_ACTIVATION_INPUT_SX_MULTILINE_READONLY
      : resolvedMultiline
        ? PRE_ACTIVATION_INPUT_SX_MULTILINE
        : PRE_ACTIVATION_OUTLINED_INPUT_SX);

  return (
    <TextField
      {...rest}
      type={resolvedType}
      multiline={resolvedMultiline}
      minRows={resolvedMinRows}
      maxRows={resolvedMaxRows}
      disabled={resolvedDisabled}
      InputProps={resolvedInputProps}
      sx={resolvedSx}
    />
  );
};

export default IntakeTextField;
